'use client';

import Link from '@eliadmin/core/src/components/link';

import { SignInDialog } from '@eliadmin/core/src/components/dialog/lazy-dialogs';
import { prefetchSocialAuthProviders } from '@eliadmin/core/src/components/auth/social-auth-providers-cache';
import { useDialogStore } from '@eliadmin/core/src/components/ui/dialog';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

import { FaRegUserCircle } from 'react-icons/fa';

type HeaderProfileButtonProps = {
  className?: {
    profile?: string;
  };
  order?: number;
};

export const HeaderProfileButton = ({ className, order }: HeaderProfileButtonProps) => {
  const me = useCustomerStore(s => s.me);
  const locale = useLocaleStore(s => s.currentLocale);

  const openDialog = useDialogStore(s => s.open);

  const warmSocialAuthProviders = () => {
    void prefetchSocialAuthProviders(locale);
  };

  const handleSignInClick = () => {
    warmSocialAuthProviders();
    openDialog({
      id: SignInDialog.id,
      content: <SignInDialog />,
    });
  };

  return (
    <>
      {me ? (
        <Link
          aria-label="Môj účet"
          prefetch={false}
          href={ROUTES.PROFILE()}
          className="flex max-h-12 min-h-12 min-w-12 max-w-12 items-center justify-center bg-white/10 text-white hover:bg-white/15"
        >
          <FaRegUserCircle size={20} />
        </Link>
      ) : (
        <button
          type="button"
          aria-label="Prihlásenie"
          onClick={handleSignInClick}
          className="flex max-h-12 min-h-12 min-w-12 max-w-12 cursor-pointer items-center justify-center bg-white/10 text-white hover:bg-white/15"
        >
          <FaRegUserCircle size={20} />
        </button>
      )}
    </>
  );
};
